/* eslint-disable quotes, quote-props, comma-dangle, max-len */
import { lazy } from 'react';
import DefaultTranslationComp from './en-US'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Translation } from './types';

export type { Translations } from './types';

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */ './ar-AE'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */ './de-DE'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */ './en-AU'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */ './en-CA'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */ './en-GB'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */ './en-IN'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */ './en-SG'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */ './es-CO'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */ './es-ES'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */ './es-MX'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */ './fr-CA'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */ './fr-FR'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */ './hi-IN'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */ './it-IT'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */ './ja-JP'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */ './ko-KR'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */ './nl-NL'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */ './pl-PL'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */ './pt-BR'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */ './sv-SE'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */ './ta-IN'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */ './th-TH'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */ './tr-TR'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */ './vi-VN'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */ './zh-CN'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */ './zh-TW')
};

const translationComps: Record<string, ReturnType<typeof lazy<Translation>>> = Object
  .entries(translationImports)
  .reduce((acc, [localCode, importFn]) => (
    { ...acc, [localCode]: lazy(importFn) }
  ), {})

export function getTranslationComponent(locale?: string) {
  return {
    component: (locale && locale in translationComps) ? translationComps[locale] : DefaultTranslationComp,
    locale: (locale && locale in translationComps) ? locale : 'en-US',
    translationImports
  };
}
